import React, { useEffect, useRef, useState } from "react";

import ClassMemberList from "bodycodi/cmap/app/components/cmap2020/ClassMemberList";
import up from "bodycodi/cmap/app/img/up-scheule.png";

interface ClassWaitingMember {
  waitMemberList: any[];
}

const ClassWaitingMember = ({ waitMemberList }: ClassWaitingMember) => {
  const [open, setOpen] = useState(true);
  const foldWrap = useRef<HTMLDivElement>(null);
  const fold = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!foldWrap.current) return;
    if (open) {
      foldWrap.current.style.height = "0px";
    } else {
      foldWrap.current.style.height = fold.current!.scrollHeight + 24 + "px";
    }
  }, [open]);

  const clickOpen = () => {
    setOpen(!open);
  };

  if (waitMemberList.length === 0) {
    return <></>;
  }

  return (
    <div className="rsrv-wait-member-wrap">
      <div className="title" onClick={clickOpen}>
        <div>
          예약 대기중인 회원 <span>{waitMemberList.length}</span>
        </div>
        {open ? <img src={up} style={{ transform: "rotate(180deg)" }} /> : <img src={up} />}
      </div>
      <div className="rsrv-wait-member-fold-wrap" ref={foldWrap}>
        <div className="rsrv-wait-member-fold" ref={fold}>
          <ClassMemberList
            isWatingMember={true}
            isLimit={false}
            isSeatClass={false}
            classMemberList={waitMemberList}
            clickedMembers={[]}
            reservationLimitNo={20}
            onClickMember={() => ({})}
          />
        </div>
      </div>
    </div>
  );
};

export default ClassWaitingMember;
